import { cn } from '@/shared/lib/cn';

/**
 * Ilustracao SVG inline para o fallback do ErrorBoundary global — estilo
 * "Obsidian Pulse": glass shard quebrado em line-work fino, com pequenas
 * fagulhas de primary (verde) sugerindo que algo "fritou" sem ser dramatico
 * demais.
 *
 * Tamanho default 280px largura — ocupa o centro vertical da tela mas nao
 * compete com o titulo "Algo deu muito errado" e os botoes de acao.
 *
 * Feita a partir da OPCAO A "Glass Shard com fagulhas" (ver
 * __mocks__/edge/error-boundary/option-a.tsx).
 */
export interface ErrorBoundaryIllustrationProps {
  className?: string;
}

export function ErrorBoundaryIllustration({ className }: ErrorBoundaryIllustrationProps) {
  return (
    <svg
      viewBox="0 0 280 220"
      fill="none"
      aria-hidden
      className={cn('h-auto w-[220px] sm:w-[280px]', className)}
      data-testid="error-boundary-illustration"
    >
      <circle cx="140" cy="110" r="80" fill="rgba(255,90,95,0.06)" />
      <circle cx="140" cy="110" r="60" fill="rgba(255,90,95,0.10)" />

      <path
        d="M 95 60 L 185 60 L 175 165 L 105 165 Z"
        stroke="var(--secondary-text)"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="rgba(190,199,210,0.04)"
      />

      <path d="M 130 60 L 120 165" stroke="var(--danger)" strokeWidth="2" strokeLinecap="round" />
      <path d="M 150 60 L 165 165" stroke="var(--danger)" strokeWidth="2" strokeLinecap="round" />
      <path d="M 110 110 L 175 105" stroke="var(--danger)" strokeWidth="2" strokeLinecap="round" />

      <circle cx="200" cy="55" r="3" fill="var(--primary)" />
      <circle cx="80" cy="80" r="2.5" fill="var(--primary)" opacity="0.7" />
      <circle cx="215" cy="140" r="2.5" fill="var(--primary)" opacity="0.7" />
      <circle cx="65" cy="160" r="3" fill="var(--primary)" />
      <circle cx="195" cy="180" r="2" fill="var(--primary)" opacity="0.6" />

      <path
        d="M 220 75 L 230 65 M 225 70 L 225 70"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.5"
      />
      <path
        d="M 55 105 L 45 115 M 50 110 L 50 110"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.5"
      />
    </svg>
  );
}
